import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios';
import { Url } from '../Url';

const FDelReparto = () => {
    const [total, setTotal] = useState(0)
    const { repartoSelected, setFormView, setViewOpen, modify, setModify } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof repartoSelected.productos !== 'undefined') {
                repartoSelected.productos.forEach(element => {
                    t = t + parseInt(element.montoventas)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [repartoSelected])

    const delReparto = async () => {
        const formData = new FormData()
        formData.append('idreparto', repartoSelected.idreparto);
        
        try {
            const results = await axios({
                url: Url + 'api/delReparto.php',
                method: 'POST',
                data: formData,
            })
            let aux = modify + 1;
            setModify(aux)
            setViewOpen(false)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className="w-full py-5 px-2 md:px-20 rounded-2xl" ref={componentRef}>
            <h2 className='text-center text-gray-700 text-xl'>Reparto {repartoSelected.fecha}</h2>
            {repartoSelected.apellido && (
                <div className='w-full mx-auto p-10'>
                    <p className='text-center text-lg'>Repartidor: {repartoSelected.apellido}</p>
                </div>
            )}
            {repartoSelected.productos && (
                <table className='w-full md:w-3/4 mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Producto</th>
                            <th>Lleva</th>
                            <th>Trae</th>
                            <th>Suma</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            repartoSelected.productos.map((item, index) => (
                                <tr key={index} className='border border-gray-300 p-2 text-center'>
                                    <td>{item.descripcion}</td>
                                    <td>{item.cantidadinicial}</td>
                                    <td>{item.cantidadfinal}</td>
                                    <td>$ {parseFloat(item.montoventas).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center'>
                            <th colSpan={3}>Total</th>
                            <th>$ {parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</th>
                        </tr>
                    </tbody>
                </table>
            )}
            {repartoSelected.mediosventas && repartoSelected.mediosventas.map((item, index) => (
                <p key={index} className='font-bold text-center'>{item.mediopago} - $ {parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
            ))}
            <div className="w-full rounded-lg px-3 flex justify-center mt-10 print:hidden">
                <button
                    type="button"
                    className="w-1/3 sm:w-1/4 flex shadow-md p-3 ml-3 bg-red-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                    onClick={()=>delReparto()}
                >
                    <p className='mx-auto text-center'>
                        Eliminar
                    </p>
                </button>
                <button
                    type="button"
                    className="w-1/4 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                    onClick={() => setViewOpen(false)}
                >
                    Salir
                </button>
            </div>
        </div>
    )
}

export default FDelReparto